"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsProvider = AnalyticsProvider;
exports.default = void 0;
function AnalyticsProvider(analyticsArray, callback) {
  analyticsArray.map(function (item, index) {
    if (item.status) {
      // create container
      var elem = document.createElement('div');
      var id = item.name;
      elem.id = id;
      document.body.appendChild(elem);

      // append code on container
      document.getElementById(id).innerHTML = item.code;

      // append script on container
      var script = document.createElement('script');
      script.src = item.scriptSrc;
      script.async = true;
      script.key = index;
      document.getElementById(id).appendChild(script);
    }
  });
  if (callback) callback();
}
var _default = AnalyticsProvider;
exports.default = _default;